@if (rendering && viewModel$ | async; as vm) {
  <wl-eplus-progressive-address-form
    [rendering]="rendering"
    [progressiveFormState]="vm.addressProgressiveFormState"
    [trackStep]="trackToolConfig.forStep('adres gegevens')"
  >
  </wl-eplus-progressive-address-form>
  <wl-eplus-progressive-personal-details-form
    [rendering]="rendering"
    [progressiveFormState]="vm.personalDetailsProgressiveFormState"
    [trackStep]="trackToolConfig.forStep('persoonlijke gegevens')"
  >
  </wl-eplus-progressive-personal-details-form>
  <wl-eplus-progressive-confirmation-form
    [rendering]="rendering"
    [progressiveFormState]="vm.confirmationProgressiveFormState"
    [trackStep]="trackToolConfig.forStep('controleren')"
    (submitted)="completeTool()"
  >
  </wl-eplus-progressive-confirmation-form>
}
